import { P2PProviderType } from 'enums';
import {
  P2PProviderDto,
  P2PProviderPayinConfig,
  P2PProviderPayoutConfig,
  P2PProviderPayoutLimits,
} from 'types';

const P2P_PROVIDER_BASE_CONFIG_VALUE: P2PProviderPayinConfig = {
  url: '',
  credentials: {
    apiKey: '',
    apiToken: '',
    signatureKey: '',
    password: '',
    apiSecret: '',
    apiPublic: '',
    apiPrivate: '',
    host2host: '',
  },
  enabled: false,
  pollingEnabled: false,
  responseTimeout: 0,
  expectedFee: 0,
  tradeMethods: [],
  orderMinAmount: 0,
  orderMaxAmount: 0,
  paymentTypeAmountLimits: {},
  configOverrides: {},
};

const PAYIN_CONFIG_VALUE: P2PProviderPayinConfig = {
  ...P2P_PROVIDER_BASE_CONFIG_VALUE,
  intervalCommissions: [],
  allowCustomerBank: false,
  allowProviderAmountRandomization: false,
  activeDisputeCount: 0,
  cancelEnabled: false,
};

const PAYOUT_CONFIG_VALUE: P2PProviderPayoutConfig = {
  ...P2P_PROVIDER_BASE_CONFIG_VALUE,
  orderTimeout: 0,
};

const PAYOUT_LIMITS_VALUE: P2PProviderPayoutLimits = {
  limitSum: 0,
  limitCount: 0,
};

export const P2P_PROVIDER_INITIAL_VALUE: P2PProviderDto = {
  name: '',
  type: P2PProviderType.InternalLike,
  withdrawalFee: 0,
  maxBalance: 0,
  assetCurrencyId: '',
  fiatCurrencyId: '',
  currencyExchangeId: '',
  assetCurrencyExchangeId: null,
  payinConfig: PAYIN_CONFIG_VALUE,
  payoutConfig: PAYOUT_CONFIG_VALUE,
  payoutLimits: PAYOUT_LIMITS_VALUE,
};
